export const META_TYPE = 'pnl3';
export const META_VER = 'v1';

export const CMD_PNL3_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
